import axios from "axios";
import { refreshPanierBadge } from "@components/Header/Header";

export const GET_CART = "cart/GET_CART";
export const UPDATE_CART = "cart/UPDATE_CART";
export const ADD_ITEM = "cart/ADD_ITEM";
export const DELETE_ITEM = "cart/DELETE_ITEM";
export const UPDATE_ITEM = "cart/UPDATE_ITEM";
export const ADD_COUPON = "cart/ADD_COUPON";
export const SET_COUPON_ERROR = "cart/SET_COUPON_ERROR";
export const SET_COUPON_SUCCESS = "cart/SET_COUPON_SUCCESS";
export const SET_HEADER_ADDED = "cart/SET_HEADER_ADDED";
export const RESET_CART = "cart/RESET_CART";

const initialState = {
  couponError: false,
  couponMsg: undefined,
  headerAdded: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CART:
      const { cart, headerAdded } = action.payload;
      refreshPanierBadge();
      return {
        ...cart,
        headerAdded
      };
    case SET_COUPON_ERROR:
      return {
        ...state,
        couponError: true,
        couponMsg: action.payload.error
      };
    case SET_COUPON_SUCCESS:
      return {
        ...state,
        couponMsg: action.payload.msg,
        couponError: initialState.couponError
      };
    case SET_HEADER_ADDED:
      return {
        ...state,
        headerAdded: action.payload.headerAdded
      };
    case RESET_CART:
      refreshPanierBadge();

      return initialState;
    default:
      return state;
  }
}

export const updateCart = cart => {
  return {
    type: UPDATE_CART,
    payload: {
      cart
    }
  };
};

export const setCouponError = error => {
  return {
    type: SET_COUPON_ERROR,
    payload: {
      error
    }
  };
};
export const setCouponSuccess = msg => {
  return {
    type: SET_COUPON_SUCCESS,
    payload: {
      msg
    }
  };
};

export const setHeaderAdded = headerAdded => {
  return {
    type: SET_HEADER_ADDED,
    payload: {
      headerAdded
    }
  };
};

export const resetCart = () => ({
  type: RESET_CART
});

export const getCart = () => async dispatch => {
  try {
    dispatch({ type: GET_CART });

    const { data } = await axios.get("/open_api/cart");

    dispatch(updateCart(data));
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const addItem = form => async dispatch => {
  try {
    dispatch({ type: ADD_ITEM });

    const formData = new FormData(form);

    const apiAddItemData = {
      append: true,
      pseId: parseInt(
        formData.get("thelia_cart_add[product_sale_elements_id]")
      ),
      quantity: parseInt(formData.get("thelia_cart_add[quantity]"))
    };

    const { data } = await axios.post(`/open_api/cart/add`, apiAddItemData);
    dispatch(updateCart(data.cart));

    dispatch(setHeaderAdded(true));
  } catch (error) {
    console.error(error.response);
    throw error;
  }
};

export const deleteItem = productId => async dispatch => {
  try {
    dispatch({ type: DELETE_ITEM });
    const { data } = await axios.delete(`/open_api/cart/${productId}`);
    if (data) {
      dispatch(updateCart(data));
    } else {
      deleteCoupon();
      dispatch(resetCart());
    }
  } catch (error) {
    console.error(error);
  }
};

export const updateItem = (cartItem, quantity) => async dispatch => {
  try {
    dispatch({ type: UPDATE_ITEM });

    const { data } = await axios.patch(`/open_api/cart/${cartItem}`, {
      quantity
    });
    if (data.cart) {
      dispatch(updateCart(data.cart));
    } else {
      deleteCoupon();
      dispatch(resetCart());
    }
  } catch (error) {
    console.error(error);
  }
};

export const addCoupon = form => async dispatch => {
  try {
    dispatch({ type: ADD_COUPON });

    const formData = new FormData(form);

    const { data } = await axios.post(`/front-api/order/coupon`, formData);

    dispatch(getCart());
    dispatch(setCouponSuccess(data.msg));
  } catch (error) {
    dispatch(setCouponError(error.response.data.msg));
    throw error;
  }
};

export const deleteCoupon = async () =>
  await axios.get(`/open_api/coupon/clear_all`);



// WEBPACK FOOTER //
// ./ressources/src/js/redux/modules/cart.js